<div class="generate-formular-info">
    <p>Der Antrag wird angelegt, haben Sie einen Moment geduld.</p>
</div>
